import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LicenseInfo } from '@mui/x-license';
import { getEnv } from './env';
import App from './App';
import './index.css';


// Initialize MUI X license key (supports runtime window._env_ and build-time process.env)
LicenseInfo.setLicenseKey(getEnv('REACT_APP_MUIX_LICENSE_KEY'));


// Tạo theme tùy chỉnh cho BIDV với màu sắc chính thức
const theme = createTheme({
  palette: {
    primary: {
      main: '#0052CC',
      light: '#4C9AFF',
      dark: '#0747A6',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FF8B00',
      light: '#FFB366',
      dark: '#CC6F00',
      contrastText: '#ffffff',
    },
    success: {
      main: '#36B37E',
      light: '#57D9A3',
      dark: '#00875A',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFAB00',
      light: '#FFE380',
      dark: '#FF8B00',
      contrastText: '#172B4D',
    },
    error: {
      main: '#FF5630',
      light: '#FF8B80',
      dark: '#DE350B',
      contrastText: '#ffffff',
    },
    info: {
      main: '#0065FF',
      light: '#4C9AFF',
      dark: '#0747A6',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F4F5F7',
      paper: '#ffffff',
    },
    text: {
      primary: '#172B4D',
      secondary: '#5E6C84',
      disabled: '#A5ADBA',
    },
    divider: '#DFE1E6',
  },
  typography: {
    fontFamily: '"Noto Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700, fontSize: '2.5rem' },
    h2: { fontWeight: 600, fontSize: '2rem' },
    h3: { fontWeight: 600, fontSize: '1.75rem' },
    h4: { fontWeight: 600, fontSize: '1.5rem' },
    h5: { fontWeight: 600, fontSize: '1.25rem' },
    h6: { fontWeight: 500, fontSize: '1.125rem' },
    body1: { lineHeight: 1.6 },
    body2: { lineHeight: 1.5 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#0052CC',
          boxShadow: '0 2px 8px rgba(0, 82, 204, 0.3)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
          boxShadow: '0 2px 4px rgba(0, 82, 204, 0.2)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0, 82, 204, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          border: '1px solid #DFE1E6',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(0, 82, 204, 0.15)',
            borderColor: '#0052CC',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 16, fontWeight: 500 },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': { borderColor: '#0052CC' },
            '&.Mui-focused fieldset': { borderColor: '#0052CC' },
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 8, fontWeight: 500 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
  },
});

// Tối ưu hóa render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  // </React.StrictMode>
);
